import { useLayout } from "../../../../provider/LayoutProvider";
import InfinityScroll from "../../../../components/InfinityScroll";
import EnrollmentEmptyCard from "../../../../components/EnrollmentEmptyCard";
import Filters from "./components/Filters";
import { List } from "./styles";
import useIsMobile from "../../../../hooks/deviceChecker";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { getAllEnrollments } from "../../../../store/actions/enrollment";
import EnrollmentCard from "../../../../components/EnrollmentCard";
import { CourseInDto } from "../../../../types/course.dto";

interface ComponentProps {
  enrollments: CourseInDto[];
  enrollmentsStates: {
    loading: boolean;
  };
}

const Component = ({ enrollments, enrollmentsStates }: ComponentProps) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch<Dispatch<Action>>();
  const [page, setPage] = useState(1);
  const [data, setData] = useState<CourseInDto[]>([]);
  const { setIsPageLoading, layout, setLayout, applyedFilters, resetFilters } = useLayout();

  const getEnrollments = ({ page }) => {
    dispatch(
      getAllEnrollments({
        pagination: {
          page,
          limit: 10,
        },
        filters: applyedFilters,
      })
    );
  };

  useEffect(() => {
    setLayout({
      ...layout,
      showFilters: true,
      showSearchBar: true,
      showBackButton: false,
      showSubHeader: !isMobile,
    });
  }, [isMobile]);

  useEffect(() => {
    if (!!applyedFilters && !!enrollments) {
      setData([]);
      setPage(1);
      getEnrollments({ page: 1 });
    }
  }, [applyedFilters]);

  useEffect(() => {
    if (!enrollmentsStates.loading && !!enrollments) {
      setData((state) => [...state, ...enrollments]);
    }
  }, [enrollments, enrollmentsStates]);

  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, []);

  useEffect(() => {
    if (!data || enrollmentsStates.loading) {
      setIsPageLoading(true);
    } else {
      setIsPageLoading(false);
    }
  }, [enrollmentsStates, data]);

  return (
    <>
      <div style={{ height: 10 }} />

      <Filters />

      <InfinityScroll
        loader={
          <>
            {!!data && <div style={{ height: 16 }} />}
            <List>
              {Array.from({ length: page === 1 ? 10 : 1 }, (_, index) => (
                <EnrollmentEmptyCard key={index} />
              ))}
            </List>
          </>
        }
        action={getEnrollments}
        page={page}
        setPage={setPage}
        data={data}
        active={!!enrollments && enrollments.length > 0}
        isLoading={enrollmentsStates.loading}
        style={{ padding: 10 }}
      >
        <List>
          {
            data?.map((content) => (
              <EnrollmentCard course={content} key={content.id} />
            ))
          }
        </List>
      </InfinityScroll>
    </>
  );
};

const state = ({ enrollmentStore }) => {
  const { data: enrollments, states: enrollmentsStates } =
    enrollmentStore.getAll;

  return {
    enrollments,
    enrollmentsStates,
  };
};

export default connect(state)(Component);
